import client from './client';

export const clientsApi = {
  create(data) {
    return client.post('/clients', data);
  },
  getAll() {
    return client.get('/clients');
  },
  getById(id) {
    return client.get(`/clients/${id}`);
  },
  update(id, data) {
    return client.patch(`/clients/${id}`, data);
  },
  delete(id) {
    return client.delete(`/clients/${id}`);
  },
  deletePermanent(id) {
    return client.delete(`/clients/${id}/permanent`);
  },
  uploadAvatar(id, file) {
    const formData = new FormData();
    formData.append('avatar', file);
    return client.post(`/clients/${id}/avatar`, formData, {
      headers: {
        // Dejamos que el navegador genere el boundary correcto
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  verifyPhone(id, data) {
    return client.post(`/clients/${id}/verify-phone`, data);
  },
  /** Marca teléfono verificado sin SMS (solo admin / desarrollo). */
  markPhoneVerified(id) {
    return client.post(`/clients/${id}/mark-phone-verified`);
  },
  getStripeStatus(id) {
    return client.get(`/clients/${id}/stripe/status`);
  },
  createStripeAccount(id) {
    return client.post(`/clients/${id}/stripe/create-account`);
  },
  createStripeOnboardLink(id) {
    return client.post(`/clients/${id}/stripe/onboard-link`);
  },
  createStripeDashboardLink(id) {
    return client.post(`/clients/${id}/stripe/dashboard-link`);
  },
  listTravelerRequests() {
    return client.get('/clients/traveler-requests');
  },
  approveTravelerRequest(id) {
    return client.post(`/clients/${id}/traveler-request/approve`);
  },
  rejectTravelerRequest(id) {
    return client.post(`/clients/${id}/traveler-request/reject`);
  },
};
